<div
  class="flex align-items-center justify-content-start gap-2"
  [ngClass]="viewItem.type === 'vertical' ? 'flex-column' : 'flex-row'"
>
  <div>
    <p-avatar
      *ngIf="viewItem.avatar"
      [image]="viewItem.avatar"
      styleClass="mr-2"
      [size]="viewItem.size || 'normal'"
      shape="circle"
    ></p-avatar>
    <p-avatar
      *ngIf="!viewItem.avatar"
      [label]="viewItem.name.charAt(0) + viewItem.surname.charAt(0)"
      [size]="viewItem.size || 'normal'"
      [style]="{ backgroundColor: 'var(--nova-dark)', color: 'var(--tertiary-color)' }"
      styleClass="mr-2"
      shape="circle"
    />
  </div>
  <div
    class="flex flex-column align-items-start justify-content-center"
    [ngClass]="viewItem.type === 'vertical' ? 'align-items-center' : 'align-items-start'"
  >
    <span class="font-bold mb-1" [ngClass]="viewItem.titleSize || 'text-md'"
      >{{ viewItem.name }} {{ viewItem.surname }}</span
    >
    <span *ngIf="viewItem.username" class="text font-bold">{{ viewItem.username }}</span>
    <span class="text text-muted">{{ viewItem.role }}</span>
  </div>
</div>
